export enum TargetingAddToTypeEnum {
    LIST = 'LIST',
    DISTRIBUTION = 'DISTRIBUTION',
}
